<template>
  <div class="main">
    <!-- 按钮组 -->
    <div class="main-btn">
      <el-button
        size="medium"
        type="primary"
        class="createBtn"
        @click="createNew()"
        >新建</el-button
      >

      <div class="input-search">
        <el-input
          style="width: 200px"
          v-model="searchName"
          placeholder="请输入分组名字"
        ></el-input>

        <i
          slot="suffix"
          class="el-input__icon el-icon-search"
          @click="doSeatch()"
        ></i>
      </div>
    </div>

    <!-- 表格部分 -->
    <div class="main-form-div">
      <el-table
        border
        v-loading="loading"
        :data="
          this.list.slice((currentPage - 1) * pageSize, currentPage * pageSize)
        "
        tooltip-effect="dark"
        style="width: 100%"
      >
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column type="index" width="55" label="序号"></el-table-column>
        <el-table-column
          prop="subjectGroupName"
          label="分组名称"
        ></el-table-column>

        <el-table-column label="学科">
          <template slot-scope="scope">
            <span v-for="(item, index) in scope.row.subjects" :key="index">
              <span style="margin-right: 5px">{{ item }}</span>
            </span>
          </template>
        </el-table-column>

        <el-table-column prop="timeStamp" label="创建时间"></el-table-column>
        <el-table-column prop="creator" label="创建者"></el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              @click.prevent="editRow(scope.$index, scope.row, list)"
              type="text"
              size="small"
              >编辑</el-button
            >

            <el-button
              @click.prevent="deleteRow(scope.$index, scope.row, list)"
              type="text"
              size="small"
              style="color: red"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        style="margin: 20px"
        background
        layout="total, prev, pager, next, sizes"
        @current-change="handleCurrentChange"
        :total="list.length"
        :page-size="pageSize"
        :current-page="currentPage"
        @size-change="handleSizeChange"
      ></el-pagination>
    </div>

    <!-- 模态弹出框部分 -->
    <!-- 新建/编辑窗口 -->
    <el-dialog :title="dialogTitle" :visible.sync="showEditWindow" width="40%">
      <el-form ref="formData" label-width="150px" class="dialogWindow">
        <el-form-item label="分组名称">
          <el-input
            v-model="formData.subjectGroupName"
            style="width: 300px"
          ></el-input>
        </el-form-item>

        <el-form-item label="组内学科">
          <el-select
            v-model="formData.subjectIds"
            multiple
            placeholder="请选择"
            filterable
          >
            <el-option
              v-for="item in subjectOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showEditWindow = false">取 消</el-button>
        <el-button type="primary" @click="saveData()">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "activityForm",
  data() {
    return {
      searchName: "",
      loading: false,
      currentPage: 1 /* 当前页页码 */,
      pageSize: 10 /* 每页显示的条数 */,
      list: [],
      //   新建表单属性
      formData: {
        activityId: this.$route.params.id,
        subjectGroupId: "",
        subjectGroupName: "",
        subjectIds: [],
      },

      //   弹出框属性
      showEditWindow: false,
      dialogTitle: "新建",

      //选项的属性
      subjectOption: [],
    };
  },

  mounted() {
    //请求数据
    this.getList(this.$route.params.id);
    this.getOption();
  },

  methods: {
    // 页码器的函数
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      console.log(this.currentPage); //点击第几页
    },

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
    },

    //弹出窗逻辑
    //创建按钮
    createNew() {
      this.showEditWindow = true;
      this.dialogTitle = "新建";
      this.formData.subjectGroupId = "";
      this.formData.subjectGroupName = "";
      this.formData.subjectIds = "";
    },

    //编辑按钮
    editRow(index, row) {
      this.showEditWindow = true;
      this.dialogTitle = "编辑";
      this.formData.subjectGroupId = row.subjectGroupId;
      this.formData.subjectGroupName = row.subjectGroupName;
      this.formData.subjectIds = row.subjectIds;
    },

    // 删除逻辑
    deleteRow(index, row, table) {
      this.$prompt("请输入Delete删除这条信息", "删除确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(({ value }) => {
        if (value === "Delete") {
          this.$confirm(
            "确认删除该信息吗?删除后该信息后的所有记录将被清除！",
            "删除确认",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
          )
            .then(() => {
              let deleteData = [];
              deleteData.push(row.subjectGroupId);

              //请求删除的接口
              this.axios
                .post(
                  "/api/web_subject_group_list/delete",
                  {
                    ids: deleteData,
                  },
                  { headers: { token: this.$store.state.token } }
                )
                .then((res) => {
                  if (res.data.code == 200) {
                    this.$message({
                      type: "success",
                      message: "删除成功!",
                    });

                    if (
                      table[1 + (this.currentPage - 1) * this.pageSize] == null
                    ) {
                      //如果当前页是最后一页，并且倒数第二项是空的，说明删除的是最后一页的最后一项
                      table.splice(
                        index + (this.currentPage - 1) * this.pageSize,
                        1
                      );
                      this.setCurrentPage();
                    } else {
                      table.splice(
                        index + (this.currentPage - 1) * this.pageSize,
                        1
                      );
                    }
                  } else {
                    this.$message.error("数据删除失败：" + res.data.message);
                  }
                })
                .catch((err) => {
                  this.$message.error("服务错误：" + err.response.status);
                });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消",
              });
            });
        } else {
          this.$message({
            type: "info",
            message: "输入错误，取消删除操作！",
          });
        }
      });
    },

    setCurrentPage() {
      this.currentPage = this.currentPage - 1;
      console.log(this.currentPage);
    },

    //请求数据
    getList(activityId) {
      this.loading = true;
      this.axios
        .get(
          "/api/web_subject_group_list/search",
          {
            params: {
              activityId,
              subjectGroupName: this.searchName,
            },
          },
          { headers: { token: this.$store.state.token } }
        )
        .then((res) => {
          if (res.data.code == 200) {
            this.list = res.data.data;
            this.loading = false;
          } else {
            this.$message.error("数据获取失败：" + res.data.message);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$message.error("服务错误：" + err.response.status);
          this.loading = false;
        });
    },

    //保存数据
    saveData() {
      //先做表单验证
      if (this.formData.subjectGroupName == "") {
        this.$message({
          type: "warning",
          message: "请输入分组名字",
        });
        return;
      }

      if (this.formData.subjectIds.length == 0) {
        this.$message({
          type: "warning",
          message: "请选择至少一个学科",
        });
        return;
      }

      // 提交保存新建信息接口
      this.$confirm("确认保存该信息吗?", "提交确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.createSubjectGroup(this.formData);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },

    //请求提交更新活动列表接口
    createSubjectGroup(formData) {
      this.axios
        .post(
          "/api/web_subject_group_list/update",
          {
            formData,
          },
          { headers: { token: this.$store.state.token } }
        )
        .then((res) => {
          if (res.data.code == 200) {
            this.$message({
              type: "success",
              message: "数据保存成功!",
            });
            this.getList(this.$route.params.id);
            this.showEditWindow = false;
          } else {
            this.$message.error("数据提交失败：" + res.data.message);
          }
        })
        .catch((err) => {
          this.$message.error("服务错误：" + err.response.status);
        });
    },

    //执行搜索
    doSeatch() {
      this.getList(this.$route.params.id);
    },

    //获取学科选项
    getOption() {
      this.axios
        .get(
          "/api/common_subject_list/search",
          { headers: { token: this.$store.state.token } }
        )
        .then((res) => {
          if (res.data.code == 200) {
            this.subjectOption = res.data.data;
          } else {
            this.$message.error("选项数据获取失败：" + res.data.message);
          }
        })
        .catch((err) => {
          this.$message.error("服务错误：" + err.response.status);
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styles/fontAndColor.styl';

.main-btn {
  margin: 20px;
  position: relative;
}

.createBtn {
  margin: 20px;
}

.main-form-div {
  margin: 20px;
}

.input-search {
  width: 250px;
  position: absolute;
  right: 20px;
  top: 20px;
}

.input-search div {
  display: inline-block;
}

.dialogWindow p {
  color: #909399;
}


</style>